var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37.4062C29.1655 37.4062 37.4062 29.1655 37.4062 19C37.4062 8.83451 29.1655 0.59375 19 0.59375C8.83451 0.59375 0.59375 8.83451 0.59375 19C0.59375 29.1655 8.83451 37.4062 19 37.4062Z",
    fill: "#DEE6F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7707 29.9694C32.054 27.6712 29.825 25.805 27.2607 24.5192C24.6964 23.2334 21.8676 22.5634 18.999 22.5625C16.1304 22.5616 13.3011 23.2298 10.736 24.514C8.17094 25.7982 5.94074 27.663 4.22266 29.9602C5.932 32.269 8.15856 34.1452 10.7238 35.4383C13.2891 36.7314 16.1216 37.4054 18.9943 37.4063C21.8671 37.4072 24.7 36.7349 27.2661 35.4434C29.8322 34.152 32.0599 32.2772 33.7707 29.9694Z",
    fill: "#7F90C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.1875C22.935 20.1875 26.125 16.9975 26.125 13.0625C26.125 9.12747 22.935 5.9375 19 5.9375C15.065 5.9375 11.875 9.12747 11.875 13.0625C11.875 16.9975 15.065 20.1875 19 20.1875Z",
    fill: "#7F90C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserIcon);
export default __webpack_public_path__ + "static/media/DefaultUserIcon.4d37c2fa450e952a7d858977a768f3f3.svg";
export { ForwardRef as ReactComponent };